import ProviderDeparturesContainer from './ProviderDeparturesContainer';

export default ProviderDeparturesContainer;
